import { BaseObject } from "../../../core/business-objects/base-object/base-object.model";
import { IAclFilter } from "./acl-filter.interface";
import { dictionarySelector, listSelector, Qry } from "../../business-objects/query-facade";
import { createSelector } from "reselect";
import { VasState } from "../store-type";
import { Membership } from "../../business-objects/membership/membership.model";
import { User } from "../../business-objects/user/user.model";
import { IAclFilterCustomCheck } from "./acl-filter-custom-check.interface";

export class AclFilter<T extends BaseObject> implements IAclFilter<T> {

    protected _activeUserMembershipsByAccount: dictionarySelector<Membership>;
    protected _isAccountOwnerByAccount: dictionarySelector<boolean>;

    constructor(protected customChecks: Array<IAclFilterCustomCheck<T>> = []) {

    }

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<T>): listSelector<T> {
        return createSelector(
            idsSelector,
            entitiesSelector,
            (ids, entities) => ids.map(id => entities[id])
        );
    }

    protected memberships(state: VasState): Array<Membership> {
        return state.membership.ids
            .map(id => state.membership.entities[id]);
    }

    protected selectedUserId(state: VasState): string {
        return state.user.selected;
    }

    protected selectedUser(state: VasState): User {
        return state.user.entities[state.user.selected];
    }

    protected selectedAccountId(state: VasState): string {
        return state.account.selected;
    }

    get activeUserMembershipsByAccount(): dictionarySelector<Membership> {

        if (!this._activeUserMembershipsByAccount) {

            this._activeUserMembershipsByAccount = createSelector(
                this.memberships,
                this.selectedUserId,
                (memberships, userId) => {
                    const result = {};
                    memberships
                        .filter(membership => membership.user === userId)
                        .forEach(membership => result[membership.account] = membership);
                    return result;
                });
        }

        return this._activeUserMembershipsByAccount;
    }

    get isAccountOwnerByAccount(): dictionarySelector<boolean> {

        if (!this._isAccountOwnerByAccount) {

            this._isAccountOwnerByAccount = createSelector(Qry.getInstance().account.items, Qry.getInstance().user.selected,
                (accounts, user = {} as any): { [id: string]: boolean } => {
                    const result = {};
                    accounts.forEach(account => result[account.id] = account.owner === user.id);
                    return result;
                });
        }

        return this._isAccountOwnerByAccount;
    }
}



// WEBPACK FOOTER //
// ./src/vas/store/queries/acl-filter.ts